// extracted by mini-css-extract-plugin
export default {"Container":"AddBook_Container__R+TDE","Created":"AddBook_Created__GNROK"};